import React from 'react';
import { Typography, Grid, Box } from '@mui/material';
import { MenuWithId } from 'components';
import { useTranslation } from 'react-i18next';
import { useEvents } from 'hooks';
import PropTypes from 'prop-types';
import { styled } from '@material-ui/styles';
import theme from 'theme';

const StyledGrid = styled(Grid)({
  [theme.breakpoints.up('xs')]: {
    justifyContent: 'flex-start',
  },
  [theme.breakpoints.down('xs')]: {
    justifyContent: 'center',
  },
});
const StyledBoxTypography = styled(Box)({
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.up('xs')]: {},
  [theme.breakpoints.down('xs')]: {
    marginRight: 10,
  },
});
const StyledBoxMenuWithId = styled(Box)({
  [theme.breakpoints.up('xs')]: {},
  [theme.breakpoints.down('xs')]: {
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
  },
});
const TypeFilter = ({ submitFilter }) => {
  const { t } = useTranslation();
  const { filters } = useEvents();

  const menuItems = [
    { id: 0, name: 'Any' },
    { id: 1, name: 'Error' },
    { id: 2, name: 'Warning' },
    { id: 3, name: 'Info' },
    { id: 4, name: 'Plan' },
  ];

  return (
    <StyledGrid item container xs={6} md={6} lg={6} direction="row">
      <StyledBoxTypography>
        <Typography>{t('type')}: </Typography>
      </StyledBoxTypography>
      <StyledBoxMenuWithId>
        <MenuWithId
          placeholder={t('any')}
          label={t('any')}
          menuItems={menuItems}
          selectedItem={filters?.type}
          selectItem={(item) => submitFilter({ type: item.name === 'Any' ? '' : item.name })}
          size="normal"
        />
      </StyledBoxMenuWithId>
    </StyledGrid>
  );
};

TypeFilter.propTypes = {
  submitFilter: PropTypes.func,
};

export default TypeFilter;
